import React, { useEffect, useState } from "react";
import { bookRide, getCarTypes, locationSearch } from "../../api/fetch";
import debounce from "lodash/debounce";
import { useAuth } from "../../services/AuthContext";
import BookingConfirm from "../BookingConfirmPpoUp";
import ConfettiExplosion from "react-confetti-explosion";
import { useNavigate } from "react-router-dom";

const HeroSection = ({ setOpenOTP }) => {
  const { customerUser, setIsSignInOpen } = useAuth();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Round Trip");
  const [loading, setLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [mobile_number, setMobile_Number] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [noofpassanger, setNoOfPassanger] = useState("");
  const [car_Type, setCar_Type] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const [ip, setIp] = useState("");

  const [carTypeData, setCarTypeData] = useState([]);

  const [pickupSearchQuery, setPickupSearchQuery] = useState("");
  const [dropSearchQuery, setDropSearchQuery] = useState("");
  const [pickupSearchResults, setPickupSearchResults] = useState([]);
  const [dropSearchResults, setDropSearchResults] = useState([]);
  const [selectedPickUpLocation, setSelectedPickupLocation] = useState(null);
  const [selectedDropLocation, setSelectedDropLocation] = useState(null);
  const [errors, setErrors] = useState({});

  const [bookedData, setBookedData] = useState([]);

  const [isReceiptOpen, setIsReceiptOpen] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({
    name: "User Test",
    phone: "9111111111",
    pickup: "Delhi cantt railway Junction, Kirby Place, Delhi Cc",
    drop: "Dehradun Railway Station, Railway Station Road",
    passengers: "1 Passenger",
    carType: "Sedan",
  });

  console.log("BOKKED DATA::", bookedData);

  useEffect(() => {
    if (customerUser) {
      setFullName(customerUser?.name);
      setMobile_Number(customerUser?.mobile_number);
    }
  }, [customerUser]);

  const validateForm = () => {
    let newErrors = {};
    if (!fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (!mobile_number.match(/^\d{10}$/))
      newErrors.mobile_number = "Mobile Number must be 10 digits.";
    if (!selectedPickUpLocation)
      newErrors.selectedPickUpLocation = "Pickup location is required.";
    if (!selectedDropLocation)
      newErrors.selectedDropLocation = "Drop location is required.";
    if (!noofpassanger)
      newErrors.noofpassanger = "Select the number of passengers.";
    if (!car_Type) newErrors.car_Type = "Select a car type.";
    if (!checkbox)
      newErrors.checkbox = "You must agree to the Terms & Conditions.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    fetchAllCarTypes();
  }, []);

  const fetchAllCarTypes = async () => {
    try {
      const res = await getCarTypes();
      console.log("RRESS ::", res);
      setCarTypeData(res?.cartypes);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const fetchPlaces = async (query, type) => {
    try {
      const res = await locationSearch(query);
      console.log(`SEARCH RESULTS (${type})::`, res);

      if (type === "pickup") {
        setPickupSearchResults(res);
      } else if (type === "drop") {
        setDropSearchResults(res);
      }
    } catch (error) {
      console.log("Error in search:", error);
    }
  };

  const debouncedFetchPlaces = debounce(fetchPlaces, 300);

  const handleSearch = (query, type) => {
    if (type === "pickup") {
      setPickupSearchQuery(query);
      if (query) {
        debouncedFetchPlaces(query, "pickup");
      } else {
        setPickupSearchResults([]);
      }
    } else if (type === "drop") {
      setDropSearchQuery(query);
      if (query) {
        debouncedFetchPlaces(query, "drop");
      } else {
        setDropSearchResults([]);
      }
    }
  };

  const handleLocationSelect = (location, type) => {
    if (type === "pickup") {
      setSelectedPickupLocation(location?.geometry);
      setPickupSearchQuery(location.description);
      setPickupSearchResults([]); // Hide pickup suggestions after selection
    } else if (type === "drop") {
      setSelectedDropLocation(location?.geometry);
      setDropSearchQuery(location.description);
      setDropSearchResults([]); // Hide drop suggestions after selection
    }
  };

  useEffect(() => {
    // Fetch the IP address
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();

        console.log("IPP ::", data);

        setIp(data?.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIp();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // setIsReceiptOpen(true);
    // setIsExploding(true);

    if (!customerUser) {
      setIsSignInOpen(true);
      return;
    }

    const isValid = validateForm();
    if (isValid) {
      var formData = {
        fullName: fullName,
        mobile_number: mobile_number,
        emailAddress: emailAddress,
        pickupLocation: selectedPickUpLocation,
        dropLocation: selectedDropLocation,
        car_Type: car_Type,
        noofpassanger: noofpassanger,
        ip_address: ip,
        trip_type: activeTab,
      };

      console.log("FORMDATTA L::", formData);
      try {
        const res = await bookRide(formData);
        console.log("RESS ::", res);
        if (res?.status) {
          setBookedData(res?.data);
          setIsReceiptOpen(true);
        }
      } catch (error) {
        console.log("Erroor ::", error);
      }
    }
  };

  const renderForm = () => {
    return (
      <div className="font-Poppins lg:p-6 p-2 px-4 py-[1rem]">
        <div className="text-center lg:mb-5 mb-2">
          <h2 className="md:text-2xl text-lg font-bold text-gray-800">
            Book Your Ride
          </h2>
          <p className="text-gray-600 text-sm md:text-lg">
            Fill in the details to book your trip!
          </p>
        </div>
        <div className="lg:space-y-2 space-y-3 ">
          {/* Full Name and Mobile Number */}
          <div className="flex flex-col sm:flex-row sm:space-x-3 space-y-1 sm:space-y-0">
            <div>
              <div className="flex items-center gap-2 bg-white p-2 md:p-3 rounded-lg shadow-sm border border-gray-300 hover:border-yellow-400 transition duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-yellow-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5.121 17.804A12.072 12.072 0 0112 15c2.132 0 4.147.555 5.879 1.804m-11.758 0A12.044 12.044 0 003 12c0-1.505.276-2.94.764-4.253m16.472 8.057A12.07 12.07 0 0012 15m6.879 2.804A12.044 12.044 0 0021 12c0-1.505-.276-2.94-.764-4.253m0 0A12.044 12.044 0 0012 3c-1.505 0-2.94.276-4.253.764m8.506 0A12.072 12.072 0 0112 3m0 0A12.07 12.07 0 015.121 5.879M3 12c0 3.314 1.343 6.314 3.514 8.485M12 21c-3.314 0-6.314-1.343-8.485-3.514M21 12c0-3.314-1.343-6.314-3.514-8.485"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Full Name"
                  required
                  className="w-full bg-transparent border-none focus:outline-none text-gray-700"
                  value={fullName || customerUser?.name}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
              <div>
                {errors?.fullName && (
                  <p className="text-red-500  md:text-sm text-xs mt-1">
                    {errors?.fullName}
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className="flex items-center gap-2 bg-white p-2 md:p-3 rounded-lg shadow-sm border border-gray-300 hover:border-yellow-400 transition duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-yellow-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7-5m0 0l7 5m-7-5v10m5 5h5m-5 0a2 2 0 01-2-2m-6 0a2 2 0 002-2"
                  />
                </svg>
                <input
                  type="tel"
                  placeholder="Mobile Number"
                  className="w-full bg-transparent border-none focus:outline-none text-gray-700"
                  value={mobile_number || customerUser?.mobile_number}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setMobile_Number(value);
                  }}
                />
              </div>
              <div>
                {errors?.mobile_number && (
                  <p className="text-red-500  md:text-sm text-xs mt-1">
                    {errors?.mobile_number}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Pickup Location */}
          <div className="relative">
            <div>
              <div className="flex items-center gap-2 bg-white p-2 md:p-3 rounded-lg shadow-sm border border-gray-300 hover:border-yellow-400 transition duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-yellow-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 2C8.134 2 5 5.134 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Pickup Location"
                  required
                  className="w-full bg-transparent border-none focus:outline-none text-gray-700"
                  value={pickupSearchQuery}
                  onChange={(e) => handleSearch(e.target.value, "pickup")}
                />
              </div>
              <div>
                {errors?.selectedPickUpLocation && (
                  <p className="text-red-500  md:text-sm text-xs mt-1">
                    {errors?.selectedPickUpLocation}
                  </p>
                )}
              </div>
            </div>

            {/* Display search results */}
            {pickupSearchResults.length > 0 && (
              <div className="absolute left-0 right-0 mt-1 bg-white border rounded-lg shadow-md max-h-60 overflow-y-auto z-10">
                {pickupSearchResults?.map((result) => (
                  <div
                    key={result?.place_id}
                    onClick={() => handleLocationSelect(result, "pickup")}
                    className="px-4 py-2 cursor-pointer hover:bg-yellow-100"
                  >
                    <p className="text-gray-700">{result?.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Drop Location */}
          <div className="relative">
            <div>
              <div className="flex items-center gap-2 bg-white p-2 md:p-3 rounded-lg shadow-sm border border-gray-300 hover:border-yellow-400 transition duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-yellow-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 2C8.134 2 5 5.134 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Drop Location"
                  required
                  className="w-full bg-transparent border-none focus:outline-none text-gray-700"
                  value={dropSearchQuery}
                  onChange={(e) => handleSearch(e.target.value, "drop")}
                />
              </div>
              <div>
                {errors?.selectedDropLocation && (
                  <p className="text-red-500  md:text-sm text-xs mt-1">
                    {errors?.selectedDropLocation}
                  </p>
                )}
              </div>
            </div>

            {/* Display search results */}
            {dropSearchResults?.length > 0 && (
              <div className="absolute left-0 right-0 mt-1 bg-white border rounded-lg shadow-md max-h-60 overflow-y-auto z-10">
                {dropSearchResults?.map((result) => (
                  <div
                    key={result?.place_id}
                    onClick={() => handleLocationSelect(result, "drop")}
                    className="px-4 py-2 cursor-pointer hover:bg-yellow-100"
                  >
                    <p className="text-gray-700">{result?.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Other Fields */}
          <div className="space-y-3">
            <select
              className="w-full px-1.5 md:px-2 md:py-3 py-2 bg-white border rounded-lg shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              value={noofpassanger}
              onChange={(e) => setNoOfPassanger(e.target.value)}
            >
              <option value="" disabled selected>
                No. of Passengers
              </option>
              {[...Array(10)].map((_, i) => (
                <option key={i + 1} value={i + 1} className="font-Poppins">
                  {i + 1} Passenger{i > 0 && "s"}
                </option>
              ))}
            </select>
            {errors?.noofpassanger && (
              <p className="text-red-500  md:text-sm text-xs mt-1">
                {errors?.noofpassanger}
              </p>
            )}
            <select
              className="w-full px-1.5 md:px-2 md:py-3 py-2 bg-white border rounded-lg shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              value={car_Type}
              onChange={(e) => setCar_Type(e.target.value)}
            >
              <option value="" disabled selected>
                Car Type
              </option>
              {carTypeData?.map((it, i) => (
                <option key={i} value={it?.id} className="font-Poppins ">
                  {it?.name}
                </option>
              ))}
            </select>
            {errors?.selectedDropLocation && (
              <p className="text-red-500 text-sm mt-1">
                {errors?.selectedDropLocation}
              </p>
            )}
          </div>

          {/* Terms */}
          <div className="flex items-center space-x-2 mt-1">
            <input type="checkbox" onChange={() => setCheckbox(!checkbox)} />
            <p className="text-gray-600 md:text-lg text-sm">
              I agree to the{" "}
              <span onClick={()=>navigate("/TermsAndConditions")} className="text-blue-500 underline cursor-pointer">
                Terms & Conditions
              </span>
            </p>
          </div>
          <div>
            {errors?.checkbox && (
              <p className="text-red-500  md:text-sm text-xs mt-1">
                {errors?.checkbox}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            // disabled={checkbox}
            className={`w-full py-1.5 md:py-3 text-md md:text-lg rounded-full bg-yellow-400 text-white font-medium shadow-lg hover:bg-gray-800 hover:opacity-90 transition duration-300`}
          >
            {loading ? (
              <>
                <div className="flex justify-center mb-4">
                  <img
                    src="https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif" // Replace this with your preferred GIF URL
                    alt="Confirmation"
                    className="w-24 h-24"
                  />
                </div>
              </>
            ) : (
              <>Book Ride</>
            )}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="relative w-full overflow-hidden h-full md:py-[4rem] py-[3rem]">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source
          src="https://carrgohtml.tortoizthemes.com/assets/bg-video-2.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Blur Effect */}
      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between max-w-7xl mx-auto px-4 sm:px-8 h-full">
        {/* Left Content */}
        <div className="text-white hidden lg:inline max-w-md space-y-6">
          <h1 className="text-4xl sm:text-5xl font-bold font-Poppins">
            Now, <span className="text-yellow-400">Book Ride </span> <br />
            with <br />
            <span className="bg-black text-white px-2 py-1 inline-block">
              Taxica <span className="text-yellow-400">India.</span>
            </span>
          </h1>
          <p className="text-gray-300 font-Poppins">
            Partner with us to drive your own livelihood and more.
          </p>
          <div className="flex space-x-4">
            {/* <img
              src="https://carrgohtml.tortoizthemes.com/assets/images/download-1.webp"
              alt="Download from Apple App Store"
              className="hover:opacity-80 rounded-lg w-32"
            /> */}
            <a
              href="https://play.google.com/apps/testing/com.maapa2019.taxidriverapp"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="./assets/download.webp"
                alt="Download from Google Play Store"
                className="hover:opacity-80 rounded-lg w-54"
              />
            </a>
          </div>
        </div>

        {/* Right Form */}

        <div className="w-full lg:w-2/5 bg-white rounded-xl shadow-md overflow-hidden mt-6 lg:mt-0">
          {/* Tab Header */}
          <div className="flex bg-gray-50 border-b">
            <button
              className={`flex-1 px-3 lg:py-6 py-3 text-center font-medium lg:text-xl text-lg text-gray-700 hover:text-yellow-500 hover:bg-gray-800 border-b-4 transition-colors duration-300 ${
                activeTab === "Round Trip"
                  ? "text-yellow-500 border-yellow-400 bg-gray-800"
                  : "border-gray-200"
              }`}
              onClick={() => setActiveTab("Round Trip")}
            >
              Round Trip
            </button>
            <button
              className={`flex-1 px-3 lg:py-6 py-3 text-center font-medium lg:text-xl text-lg text-gray-700 hover:text-yellow-500 hover:bg-gray-800 border-b-4 transition-colors duration-300 ${
                activeTab === "One Way Trip"
                  ? "text-yellow-500 border-yellow-400 bg-gray-800"
                  : "border-gray-200"
              }`}
              onClick={() => setActiveTab("One Way Trip")}
            >
              One Way Trip
            </button>
          </div>

          {/* Form Content */}
          <div className="">{renderForm()}</div>

          <div>
            {/* Receipt Pop-up */}
            {isReceiptOpen && (
              <div className="fixed inset-0 backdrop-blur-sm  flex items-center justify-center bg-black bg-opacity-50 font-Poppins">
                <div className="bg-white p-6 rounded-xl shadow-lg w-1/4">
                  <ConfettiExplosion
                    width={window.innerWidth}
                    height={window.innerHeight}
                    zIndex={50}
                    particleCount={800}
                    particleSize={15}
                  />

                  {/* Green Check Animation */}
                  <div className="flex justify-center mb-6 relative">
                    <div className="w-12 h-12 rounded-full border-4 border-green-500 flex items-center justify-center animate-ping bg-green-100">
                      <svg
                        className="w-8 h-8 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="3"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-center mb-4">
                    Booking Confirmed! 🎉
                  </h3>
                  <h4 className="text-2xl font-bold text-center mb-4">
                    Your Ride id : ( {bookedData?.id})
                  </h4>
                  <div className="space-y-4">
                    <div>
                      <strong>
                        <span className="text-gray-500">📛</span> Trip Type:
                      </strong>{" "}
                      {bookedData?.trip_type}
                    </div>
                    <div>
                      <strong>
                        <span className="text-gray-500">📛</span> Name:
                      </strong>{" "}
                      {customerUser?.name}
                    </div>
                    <div>
                      <strong>
                        {" "}
                        <span className="text-gray-500">📞</span> Phone:
                      </strong>{" "}
                      {customerUser?.mobile_number}
                    </div>
                    <div>
                      <strong>
                        <span className="text-gray-500">📍</span> Pickup
                        Location:
                      </strong>{" "}
                      {bookedData?.pickup_address}
                    </div>
                    <div>
                      <strong>
                        <span className="text-gray-500">🏁</span> Drop Location:
                      </strong>{" "}
                      {bookedData?.drop_address}
                    </div>
                    <div>
                      <strong>
                        {" "}
                        <span className="text-gray-500">👥</span> Passengers:
                      </strong>{" "}
                      {bookedData?.no_of_passengers}
                    </div>
                    <div>
                      <strong>
                        {" "}
                        <span className="text-gray-500">🚗</span> Car Type:
                      </strong>{" "}
                      {car_Type}
                    </div>
                  </div>
                  <button
                    onClick={() => setIsReceiptOpen(false)}
                    className="mt-4 w-full bg-gray-800 hover:bg-gray-900 text-white py-2 px-4 rounded-lg cursor-pointer"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
